import React, { useEffect, useState } from 'react';
import { EmptyState } from './emptyState';
import { LoadingState } from '../../../../_common/loadingState';
import { InvoiceList } from './invoiceList';
import { fetchInvoices } from '../../../../actions/facilita-api';
import { Header } from '../_common/header';
import Invoice from '../../../../constants/models/invoice';


export const SettingsInvoicing = ({ user, roles }) => {
	const [invoicesState, setInvoicesState] = useState({
		invoices: [],
		isLoading: false
	});

	useEffect(() => {
		setInvoicesState({ ...invoicesState, isLoading: true });
		fetchInvoices(user.id).then((invoices) => {
			setInvoicesState({ ...invoicesState, isLoading: false, invoices: invoices.length > 0 ? invoices.map(i => new Invoice(i)) : [] });
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<article className="view-calc pt-sm mb-auto">
			<Header roles={roles} />
			<div className="auto-view h-100 mb-auto pt-3">
				<div className="container-fluid h-xl-inherit">
					{invoicesState.isLoading ? <section className="col flex-column justify-content-center py-sm-5 h-xl-inherit text-center"><LoadingState /></section> :
						invoicesState.invoices.length === 0 ?
							<EmptyState />
							:
							<InvoiceList invoices={invoicesState.invoices} />
					}
				</div>
			</div>
		</article>
	);
};